/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Meta_PageInputs */

const ja_work_meta_page = /** @type {(inputs: Work_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`work`)
};

const en_work_meta_page = /** @type {(inputs: Work_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`work`)
};

/**
* | output |
* | --- |
* | "work" |
*
* @param {Work_Meta_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const work_meta_page = /** @type {((inputs?: Work_Meta_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Meta_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_work_meta_page(inputs)
	return en_work_meta_page(inputs)
});